import React from 'react';
import classNames from 'classnames';
import './styles.css';

const Button = ({
  children,
  className,
  variant = 'primary',
  rounded,
  icon: Icon,
  iconProps,
  iconPosition = 'left',
  size = 'l',
  ...props
}) => {
  return (
    <button
      className={classNames(
        'button',
        `size--${size}`,
        `icon--${iconPosition}`,
        `variant--${variant}`,
        {
          'button--rounded': rounded,
          'has--text': !!children,
        },
        className,
      )}
      {...props}
    >
      {Icon && (
        <Icon
          size={16}
          {...iconProps}
        />
      )}
      {children}
    </button>
  );
};

export default Button;
